import { render } from "./ComparerPopup.vue?vue&type=template&id=f199e9b8"
import script from "./ComparerPopup.vue?vue&type=script&lang=js"
export * from "./ComparerPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__